import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useSearchParams } from 'react-router-dom';
import { MDBBtn, MDBIcon, MDBInput } from 'mdb-react-ui-kit';
import { Alert } from '../components/Alert';
import API from '../service/api';
import { host } from '../service/host';
import { TextInput } from '../components/core/inputs/TextInput';
import { PasswordInput } from '../components/core/inputs/PasswordInput';



export const AuthPage = ({onLogin, initialError}) => {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isWaiting, setIsWaiting] = useState(false);
    const [message, setMessage] = useState(searchParams.get('success') ? t('password_changed_success') : '');
    const [error, setError] = useState(initialError||'');


    useEffect(() => {
        if (searchParams.get('success')) setMessage(t('password_changed_success'));
    }, []);

    const doLogin = async () => {
        setIsWaiting(true);
        try {
            onLogin(await API.login(email, password));
        }catch(err){
            setError(`${err.message}`);
        }finally{
            setIsWaiting(false);
        }
    }

    return (
        <section className="h-100">
            <div className="container-fluid h-100 ">
                <div className="row d-flex justify-content-center align-items-center h-100">
                    <div className="h-100 w-100 col-sm-6 text-black d-flex flex-column justify-content-center align-items-center">
                        <div className="d-flex flex-column flex-fill align-items-center h-custom-2 justify-content-center mb-5 ">
                            <div className="d-flex flex-column align-items-center pt-5 mb-5">
                                <img src={`/logo.png`} style={{width: 128, height: 128}}/>
                                <span className="h2 fw-bold mb-0">{host.getTitle()}</span>
                            </div>

                            <form style={{width: '80vw', maxWidth: '25rem'}}>

                                <h3 className="fw-normal mb-3 pb-3" style={{letterSpacing: "1px"}}>{t('login')}</h3>
                                <TextInput label={t('email_address')} value={email} onValueChange={setEmail}/>
                                <PasswordInput label={t('password')} value={password} onValueChange={setPassword}/>

                                <Alert type="danger" message={error}/>
                                <Alert type="success" message={message}/>

                                <MDBBtn size="lg" block type="button" disabled={isWaiting} onClick={doLogin} className="mt-1 mb-2">{t('login')}</MDBBtn>
                                <div className='d-flex flex-row justify-content-end'>
                                    <NavLink to="/reset"><span role="button" className="text-primary">{t('forgot_password')}</span></NavLink>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}